import { render, staticRenderFns } from "./SDKList.vue?vue&type=template&id=d3b68a4a&scoped=true"
import script from "./SDKList.vue?vue&type=script&lang=js"
export * from "./SDKList.vue?vue&type=script&lang=js"
import style0 from "./SDKList.vue?vue&type=style&index=0&id=d3b68a4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3b68a4a",
  null
  
)

export default component.exports